import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { graphqlRequest} from '../../services/graphql-service';
import { GET_ARTIST_WITH_TRACKS} from '../../config/queries.js';
import './artist.css';
import Footer from '../footer/footer';
import {artist_stream_data, artist_temp_traits} from '../../config/artist-temp-stream-data';
import ArtistStreamDetails from '../artist-stream-details/artist-stream-details';
import socialYoutube from '../../assets/images/social/white/youtube.png';
import socialSpotify from '../../assets/images/social/white/spotify.png';
import socialTiktok from '../../assets/images/social/white/tiktok.png';
import SkillTag from '../skill-tag/skill-tag.js';
import { setModal } from '../../features/dialogControl/dialogControlSlice';

const truncateSkillTags = (tags, containerRef) => {
    if (!containerRef.current) return tags;

    let totalWidth = 0;
    let visibleTags = [];
    const containerWidth = containerRef.current.offsetWidth; 

    for (let tag of tags) {
        // Create a temporary element to measure width
        const tempTag = document.createElement("div");
        tempTag.className = "skill-tag-container";
        tempTag.style.position = "absolute";
        tempTag.style.visibility = "hidden";
        tempTag.style.whiteSpace = "nowrap";
        tempTag.innerText = tag;
        document.body.appendChild(tempTag);

        const tagWidth = tempTag.offsetWidth; // Get actual width
        document.body.removeChild(tempTag);

        if (totalWidth + tagWidth > containerWidth) break; // Stop if overflow

        visibleTags.push(tag);
        totalWidth += tagWidth + 10; // Add spacing
    }

    return visibleTags;
};


const Artist = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const containerRef = React.useRef(null);
    
    const [artistData, setArtistData] = useState(null);
    const bioLimit = 700;

    // TODO: get real titles for artists into DB
    const artistTitles = [
        'ARTIST',
        'PRODUCER',
        'DRUMMER',
        'DAO MEMBER',
        'SOLO ARTIST',
        'BAND ARTIST'
    ];

    // const getTraitList = () => {
    //     return [...artist_temp_traits].sort(() => 0.6 - Math.random());
    // }

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [randomTraits, setRandomTraits] = useState(null);
    useEffect(() => {
        const fetchTrackData = async () => {
            try {
                setLoading(true);
                const data = await graphqlRequest(GET_ARTIST_WITH_TRACKS, { artistId: id }); 
                setArtistData(data.artist)
                // const sortedTracks = data.artist.tracks.sort( (a,b) => a.title.localeCompare(b.title))
                // setTrackData(sortedTracks);
                // setFilteredTracks(sortedTracks);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        
        fetchTrackData();

        // pick 6 random traits
        const shuffledTraits = [...artist_temp_traits]
        .sort(() => Math.random() - 0.5)
        .slice(0, 10);
    
        setRandomTraits(shuffledTraits);
    }, [id]);

    const visibleTags = truncateSkillTags(artistTitles, containerRef);
    
    const setModalContent = (event, modal) => {
        event.stopPropagation();
        dispatch(setModal(modal));
    }

    const truncateText = (copy, title, maxLength) => {
        if (copy.length > maxLength) {
            return (
                <span>
                    {copy.substring(0, maxLength)}...
                    <span 
                        className="truncated-more-link" 
                        onClick={(e) => setModalContent(e, { 
                            visible: true, 
                            title: title, 
                            copy 
                        })}
                    >
                        (more)
                    </span>
                </span>
            );
        }
        return copy;
    };


    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    return (
      <div className='artist-page-container'>
        
        <div className='artist-summary-block'>
            <div className="artist-blurred-bg">
                <div className="artist-blur-layer"
                    style={{
                        background: `url(https://media.tracktribe.com/images/artists/${artistData.image}) no-repeat center center/cover`
                    }}
                ></div>
                    <div className='artist-summary-block-content'>
                        <img className='artist-hero-image' src={`https://media.tracktribe.com/images/artists/${artistData.image}`} alt='' />
                        <div className='artist-details-block'>
                            <div className='artist-title'>{artistData.artist_name}</div>
                            <div 
                                className='artist-details-taglist'
                                ref={containerRef}
                                onClick={(e) => setModalContent(
                                    e,
                                    {
                                        visible:true, 
                                        title:'Artist Tags', 
                                        copy: artistTitles.join(', ')
                                    }
                                )}
                            >
                                {visibleTags.map((t) => {
                                    return <SkillTag key={t} tag={t} />
                                })}    
                            </div>
                            <div className='artist-stream-details-group'>
                                <ArtistStreamDetails 
                                    first={true}
                                    label='TOTAL STREAMS' 
                                    value={artist_stream_data.total.streams}
                                    performance={artist_stream_data.total.performance}
                                />
                                <ArtistStreamDetails 
                                    label='SPOTIFY' 
                                    value={artist_stream_data.spotify.streams}
                                    performance={artist_stream_data.spotify.performance}
                                    logo={socialSpotify}
                                />
                                <ArtistStreamDetails 
                                    label='TIKTOK' 
                                    value={artist_stream_data.tiktok.streams}
                                    performance={artist_stream_data.tiktok.performance}
                                    logo={socialTiktok}
                                />
                                <ArtistStreamDetails 
                                    label='YOUTUBE' 
                                    value={artist_stream_data.youtube.streams}
                                    performance={artist_stream_data.youtube.performance}
                                    logo={socialYoutube}
                                />
                            </div>
                        </div>
                    </div>
                {/* </div> */}
            </div>
        </div>

        <div className='content-block content-block-radial-background'>
            <div className='artist-showcase-block-container'>
                <div className='artist-showcase-block-left'>
                    <div className='artist-showcase-block-left-header'>
                        <div className='artist-title'>Artist Bio</div>
                        <div className='artist-showcase-block-left-search-container'>Search Form</div>
                    </div>
                    <div className='artist-bio-container'>{truncateText(artistData.bio,artistData.artist_name,bioLimit)}</div>
                    <div className='artist-discography-header-container'>
                        <div className='artist-sub-header'>Explore Discography</div>
                        <div className='nav-link'
                            // TODO: standardize this type of right side small copy
                            style={{ 
                                minWidth: '90px',
                                textAlign: 'right'
                            }}
                        >SEE ALL</div>
                    </div>
                </div>
                <div className='artist-showcase-block-right'>
                    <div className='artist-title'>Traits</div>
                    {randomTraits.map((t) => {
                        return <div className='artist-trait-tag' key={t}>{t}</div>
                    })}
                </div>
            </div>
        </div>

        
        <Footer />
      </div>
    );
};

export default Artist;